module.exports = __webpack_public_path__ + "e5dd0a5405bebda6e3b53f6d17ed8346.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/767.png
// module id = 1694
// module chunks = 2